import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cree-devis',
  templateUrl: './cree-devis.component.html',
  styleUrls: ['./cree-devis.component.scss']
})
export class CreeDevisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
